import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { useRouter } from 'next/router';
import { Card, Table } from '@avila-tek/ui/src';
import { PaymentMethod, Currency, Pagination, PageInfo } from '../../models';
import { ActiveDotCell } from '../shared';

const columnHelper = createColumnHelper<PaymentMethod>();

const columns = [
  columnHelper.accessor('title', {
    header: 'Nombre',
  }),

  columnHelper.accessor('currency', {
    header: 'Moneda',
    cell: (info) => (info.getValue() as Currency)?.name,
  }),

  columnHelper.accessor('commission', {
    header: 'Comisión',
    cell: (info) => `${info.getValue()}%,`,
  }),

  columnHelper.accessor('active', {
    header: 'Estatus',
    cell: (info) => <ActiveDotCell active={info?.getValue()} />,
  }),
];

interface PaymentMethodTableProps {
  data: Pagination<PaymentMethod>;
  pagination: Partial<PageInfo>;
  setPagination: React.Dispatch<React.SetStateAction<Partial<PageInfo>>>;
}

function PaymentMethodTable({
  data,
  pagination,
  setPagination,
}: PaymentMethodTableProps) {
  const router = useRouter();

  const onClickRow = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;
    router.push(`/app/settings/payment/${id}`);
  };

  const onClickAddButton = () => router.push('/app/settings/payment/create');

  const handleGoToPage = (value: number) => {
    setPagination({ ...pagination, currentPage: value });
  };

  return (
    <Card className="overflow-x-auto p-5">
      <Table<PaymentMethod>
        data={data?.items}
        columns={columns}
        href="/app/maintenance/sales/create"
        manualPagination
      >
        <Table.Header>
          <Table.SearchInput />
          <Table.AddButton title="Método de pago" action={onClickAddButton} />
        </Table.Header>
        <Table.Content<PaymentMethod> onClickRow={onClickRow} />
        <Table.Footer>
          <Table.Pagination
            handleGoToPage={handleGoToPage}
            paginationInfo={{
              count: data.count,
              pageInfo: { ...data.pageInfo },
            }}
            className="ml-auto"
          />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default PaymentMethodTable;
